<template>
  <ToolAdmin
    :user="user"
    tool-id="CustomerServiceCallAnalysis"
    tool-name="Call Analysis"
    tool-icon="mdi-phone"
  />
</template>

<script>
import ToolAdmin from './ToolAdmin.vue'

export default {
  name: 'CallAnalysisAdmin',
  components: {
    ToolAdmin
  },
  props: ['user']
}
</script> 